module.exports = __webpack_public_path__ + "static/8-16361ef6421ad8ca324cc2ba9f965604.jpeg";